import React from 'react'
import { IInfrastructureProject, IStreet } from '../../../types/project.types'
import classes from '../infrastructure-tabs/styles.module.scss'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../home/components/left-menu/info.component'
interface IProps {
    data: any
}

const translationKey = 'projects.infrastructure-projects'

const Documentation = ({ data }: IProps) => {
    const { t, i18n: { language } } = useTranslation();
    const suffix = language === 'ru' ? 'Ru' : 'Kz';
    if (!data) return null;
    return (
        data.documentationStatus !== 'HAVE' && data.documentationStatus ? <>
            <div className={classes['field-row__item']}>
                <span className={classes['field-row__value']}>{t(`${translationKey}.documentation.${data.documentationStatus}`)}</span>
            </div>
        </> :
            <>
                <div className={classes['field-row']}>
                    {['workStart', 'workEnd', 'requiredFundSource', 'requiredFundAmount'].map(field => {
                        const valueKey = field === 'requiredFundSource' ? `${field}${suffix}` : field;
                        const val = data[valueKey as keyof IInfrastructureProject | keyof IStreet] as string | number | undefined
                        const value = field.startsWith('work')
                            ? val && formatDate(val.toString())
                            : val;
                        return (
                            <div className={classes['field-row__item']}>
                                <span className={classes['field-row__label']}>{t(`${translationKey}.${field}`)}:</span>
                                <span className={classes['field-row__value']}>
                                    {value}
                                </span>
                            </div>
                        )
                    })}
                </div>

                {
                    data.requiredFund && Object.keys(data.requiredFund).length > 0 && (
                        <div className={classes['field-block']}>
                            <div className={classes['field-block__title']}>
                                {t(`${translationKey}.fundSources`)}
                            </div>
                            <div className={classes['field-row']}>
                                {Object.entries(data.requiredFund).map(([key, value]: [string, any]) => (
                                    <div key={key} className={classes['field-row__item']}>
                                        <span className={classes['field-row__label']}>
                                            {value[`label${suffix}`]}:
                                        </span>
                                        <span className={classes['field-row__value']}>{value.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                }
            </>

    )
}

export default Documentation